import { render, staticRenderFns } from "./AuthMatchMaking.vue?vue&type=template&id=3db69659&scoped=true&"
import script from "./AuthMatchMaking.vue?vue&type=script&lang=js&"
export * from "./AuthMatchMaking.vue?vue&type=script&lang=js&"
import style0 from "./AuthMatchMaking.vue?vue&type=style&index=0&id=3db69659&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db69659",
  null
  
)

export default component.exports